import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button, Image, Accordion,Card } from 'react-bootstrap';
import './Education.scss';

const Experience = (props) => {
    const { student, showDocumentModal } = props;
    let experience = null;
    if(student.experience && student.experience.length) {
        experience = student.experience.map(acad => {
            return (<div className="academic">
                <div className="degree-type">{acad.company_name}</div>
                <div className="degree-name">{acad.experience} years</div>
                <Row>
                {acad.exp_doc_url? <Col md="4" className="inside-container" onClick={()=> showDocumentModal(acad.exp_doc_url)}>
                 <span>Document</span>
          <FontAwesomeIcon className={"icon-inside"} icon={['fas', 'file-contract']} />

                 </Col>:null}
             </Row>
            </div>)
        })
    }
    return (
        // <Row className="education-section">
        //     <Col>
        //         <h3>Experience</h3>
        //         {experience}
        //         <div></div>
        //     </Col>
        // </Row>
           <div className="education-section">
           <Accordion >
           <Card>
             <Accordion.Toggle as={Card.Header} eventKey="0">
             <h3>Experience</h3>
          <FontAwesomeIcon className={"icon"} icon={['fas', 'plus']} />

             </Accordion.Toggle>
             <Accordion.Collapse eventKey="0">
               <Card.Body>
                {experience}
   
               </Card.Body>
             </Accordion.Collapse>
           </Card>
         </Accordion>
         </div>
    )
}
export default Experience;
